// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "email-editor/css/" + chunkId + "." + "e3826d79" + ".chunk.css";
};